import { alpha } from '@mui/material/styles';
import { gray, brand } from '../../getDesignTokens';

/**
 * MuiSlider — the range / value slider. Painted with a brand gradient
 * track, a white circular thumb with brand border, and hover / active
 * ring shadows for feedback.
 *
 * All five slot overrides are treated together (root, rail, track,
 * thumb, mark, markActive, valueLabel) because they're a coordinated
 * visual set — changing the thumb size, for example, means updating
 * the ring shadow radii too.
 */
export const sliderCustomizations = {
  MuiSlider: {
    styleOverrides: {
      root: () => ({
        color: brand[500],
        height: 4,
        padding: '13px 0',
        '&.Mui-disabled': {
          color: gray[300],
        },
      }),
      rail: ({ theme }) => ({
        height: 4,
        borderRadius: 2,
        opacity: 1,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[700],
        }),
      }),
      track: () => ({
        height: 4,
        borderRadius: 2,
        border: 'none',
        backgroundImage: `linear-gradient(to right, ${brand[400]}, ${brand[500]})`,
      }),
      thumb: ({ theme }) => ({
        height: 16,
        width: 16,
        backgroundColor: '#fff',
        border: `2px solid ${brand[500]}`,
        boxShadow: `0 1px 2px 0 ${alpha(gray[900], 0.15)}`,
        '&:hover, &.Mui-focusVisible': {
          boxShadow: `0 0 0 6px ${alpha(brand[500], 0.16)}`,
        },
        '&.Mui-active': {
          boxShadow: `0 0 0 10px ${alpha(brand[500], 0.2)}`,
        },
        '&.Mui-disabled': {
          borderColor: gray[300],
        },
        ...theme.applyStyles('dark', {
          backgroundColor: gray[900],
          borderColor: brand[400],
        }),
      }),
      mark: ({ theme }) => ({
        backgroundColor: gray[300],
        height: 6,
        width: 2,
        ...theme.applyStyles('dark', {
          backgroundColor: gray[600],
        }),
      }),
      markActive: () => ({
        backgroundColor: brand[500],
      }),
      valueLabel: ({ theme }) => ({
        backgroundColor: brand[700],
        color: '#fff',
        fontWeight: 600,
        fontSize: '0.75rem',
        padding: '2px 6px',
        borderRadius: theme.shape.borderRadius / 2,
      }),
    },
  },
};
